import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { useApiMutation } from '../../../../infra/api';
import { endpoints } from '../../network';
import { RenameCampaignModal } from './rename-campaign-modal';
import { showNotification } from '../../../../../app/common/helpers/notifications';
import { useToggle } from '../../../../infra/small-tools/use-toggle';
import { MODAL_ANIMATION_DURATION } from '../../../../infra/dls/components/modal/modal';
import { getViewerIdAndKind, useSession } from '../../../../infra/session';
import { useEditableField } from '../../campaign-builder/hooks';
export var RenameCampaignModalContainer = function (_a) {
    var campaign = _a.campaign, onClose = _a.onClose, onSuccessUpdate = _a.onSuccessUpdate;
    var _b = useState(), error = _b[0], setError = _b[1];
    var inputRef = useRef(null);
    var toggleModalVisible = useToggle(true);
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var campaignId = campaign.id, displayName = campaign.displayName;
    var _c = useState(displayName), campaignName = _c[0], setCampaignName = _c[1];
    // to sync with the campaign creator
    var setCampaignDisplayNameRedux = useEditableField('displayName').setValue;
    var handleInputChange = function (newValue) {
        setCampaignName(newValue);
        setCampaignDisplayNameRedux(newValue);
        if (!newValue.trim()) {
            setError('Please enter a campaign name');
        }
        else {
            setError(undefined);
        }
    };
    var _d = useApiMutation({
        endpoint: endpoints.updateCampaignMutation,
        options: {
            onSuccess: function () {
                onSuccessUpdate === null || onSuccessUpdate === void 0 ? void 0 : onSuccessUpdate();
                onClose();
                showNotification({
                    title: 'Campaign Renamed Successfully',
                    message: 'Your campaign has been renamed.',
                    autoDismiss: 8,
                });
            },
        },
    }), updateCampaignMutation = _d.mutate, isLoading = _d.isLoading;
    var onUpdateName = function () {
        updateCampaignMutation({
            campaignId: campaignId,
            campaign: { displayName: campaignName },
            viewerId: viewerIdAndKind.id,
            viewerType: viewerIdAndKind.kind,
        });
    };
    var handleClose = function () {
        toggleModalVisible.setOff();
        setTimeout(function () {
            onClose();
        }, MODAL_ANIMATION_DURATION);
    };
    var textColor = isLoading ? 'disabled' : 'secondary';
    return (_jsx(RenameCampaignModal, { onClose: handleClose, inputRef: inputRef, value: campaignName, onChange: handleInputChange, isLoading: isLoading, error: error, onUpdateName: onUpdateName, textColor: textColor, toggleModalVisible: toggleModalVisible }));
};
